import { z } from 'zod';

const userSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const messageSchema = z.object({
  _id: z.string(),
  associatedEntity: z.string(),
  entityId: z.string(),
  sender: userSchema,
  receiver: userSchema.nullable(),
  content: z.union([
    z.object({
      type: z.literal('text'),
      text: z.string(),
    }),
    z.object({
      type: z.literal('image'),
      image: z.string(),
    }),
  ]),
  createdTime: z.number(),
  isRead: z.boolean(),
});

export const realtimeMessagesSchema = z.array(messageSchema);

export type RealtimeMessages = z.infer<typeof realtimeMessagesSchema>;
